import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { collection, query, where, getDocs, updateDoc, increment } from 'firebase/firestore';
import { db } from './FirebaseConfig';

function RedirectPage() {
  const { shortId } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAndRedirect = async () => {
      try {
        // Query Firestore for matching shortCode
        const q = query(
          collection(db, 'shortUrls'),
          where('shortCode', '==', shortId)
        );
        
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          const docSnapshot = querySnapshot.docs[0];
          const data = docSnapshot.data();
          
          if (data.originalUrl) {
            // Redirect immediately
            window.location.href = data.originalUrl;
            
            // Then increment clicks in the background
            // Using a try-catch block to silently fail if the update doesn't work
            try {
              await updateDoc(docSnapshot.ref, {
                clicks: increment(1)
              });
            } catch (updateError) {
              console.error('Failed to update clicks:', updateError);
            }
          } else {
            setError('No redirect URL found');
          }
        } else {
          setError('Short link not found');
        }
      } catch (err) {
        setError('Failed to fetch URL');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAndRedirect();
  }, [shortId]);


  return null;
}

export default RedirectPage;